import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2cf3bb10")

_pushScopeId("data-v-2cf3bb10")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "chooseResourceTop" }, " 资源库 ", -1)
const _hoisted_2 = { class: "chooseResourceBottom" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("导入全部页面至光标处")
const _hoisted_4 = { class: "label" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_ThumbnailSlide = _resolveComponent("ThumbnailSlide")
  const _component_Draggable = _resolveComponent("Draggable")

  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Button, {
        type: "primary",
        onClick: _ctx.importAll
      }, {
        default: _withId(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.slides, (forItem, forIndex) => {
      return (_openBlock(), _createBlock("div", {
        class: "preview",
        id: "preview",
        key: forIndex,
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.copyInnerTextOfCell && _ctx.copyInnerTextOfCell(...args)))
      }, [
        _createVNode(_component_Draggable, {
          class: "thumbnail-list",
          modelValue: _ctx.slides.slice(forIndex,forIndex+1),
          animation: 300,
          scroll: true,
          scrollSensitivity: 50,
          onDragover: _ctx.allowDrop
        }, {
          item: _withId(({ element }) => [
            _createVNode("div", {
              class: "thumbnail-item",
              onDragstart: ($event: any) => (_ctx.dragStart(forIndex))
            }, [
              _createVNode("div", _hoisted_4, _toDisplayString(_ctx.fillDigit(forIndex + 1, 2)), 1),
              _createVNode(_component_ThumbnailSlide, {
                class: "thumbnail",
                slide: element,
                size: 120
              }, null, 8, ["slide"])
            ], 40, ["onDragstart"])
          ]),
          _: 2
        }, 1032, ["modelValue", "onDragover"])
      ]))
    }), 128))
  ]))
})